import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/landing/Header";
import { useAuth } from "@/lib/auth";

/**
 * AppShell — shared layout for logged-in pages.
 * Wraps children with the site Header and ensures the user is authenticated.
 * Redirects to /login if the user is not logged in.
 */
export default function AppShell({ children, requireAuth = true, maxWidth = "1200px" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!requireAuth) {
      setChecked(true);
      return;
    }
    if (user === false) nav("/login");
    else if (user) setChecked(true);
  }, [user, requireAuth, nav]);

  if (requireAuth && !checked) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="cm-container py-24 text-center text-cm-grey">Loading…</div>
      </div>
    );
  }

  return (
    <div className="min-h-[100dvh] bg-cm-surface">
      <Header />
      <main
        className="cm-container py-6 sm:py-8 lg:py-12 w-full min-w-0"
        style={{ maxWidth }}
      >
        {children}
      </main>
    </div>
  );
}
